/* istanbul ignore file */
import { focus, maxWidthContainer } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

export const skipLinksWrapper = css`
  position: relative;

  ${maxWidthContainer};

  /* GlobalComponents Nav is currently set to 160 */
  z-index: 200;
`;

export const skipLink = css`
  ${focus};
  background: var(--neutral-white-base);
  border: 2px solid var(--brand-bluple-base);
  border-radius: 5px;
  padding: 10px 20px;

  position: absolute;
  left: -9999px;
  transform: translateY(-100%);

  &:focus {
    left: 20px;
    top: 20px;
    transform: translateY(0%);
  }
`;
